<!-- Test-only page: text here is deliberately left untranslated (out of scope per #4317). -->
<cs-header>
  <cs-header-title>Toast Component Tests</cs-header-title>
</cs-header>

<cs-content>
  <cs-card-list>
    <cs-card>
      <cs-card-header>Toast Configuration</cs-card-header>
      <cs-card-content>
        <cs-item-list>
          <!-- Toast message input -->
          <cs-item vertical>
            <cs-label>Toast Message:</cs-label>
            <cs-input [(value)]="toastMessage" [placeholder]="'Enter toast message' | untranslated"></cs-input>
          </cs-item>

          <!-- Toast type selector -->
          <cs-item vertical>
            <cs-label>Toast Type:</cs-label>
            <cs-select [(value)]="toastType">
              <cs-select-option value="success-light">Success Light (Blue Info)</cs-select-option>
              <cs-select-option value="success-strong">Success Strong (Green)</cs-select-option>
              <cs-select-option value="warning-light">Warning Light (Yellow)</cs-select-option>
              <cs-select-option value="warning-strong">Warning Strong (Red)</cs-select-option>
            </cs-select>
          </cs-item>

          <!-- Toast position toggle -->
          <cs-item>
            <cs-label>Position at Top:</cs-label>
            <cs-toggle [(checked)]="toastAtTop"></cs-toggle>
          </cs-item>

          <!-- Close control. Since #5116 the SHAPE is not chosen here: a toast with a button
               row gets a worded close inside it, one without gets the corner mark. All this
               picks is whether the toast offers a close at all. -->
          <cs-item vertical>
            <cs-label>Close Control:</cs-label>
            <cs-select [(value)]="closeButtonType">
              <cs-select-option value="none">None (timer only)</cs-select-option>
              <cs-select-option value="default">Yes (shape follows the layout)</cs-select-option>
              <cs-select-option value="dismiss">Yes, with custom text</cs-select-option>
            </cs-select>
          </cs-item>

          <!-- Don't show again -->
          <cs-item>
            <cs-label>Include "Never Show" Button:</cs-label>
            <cs-toggle [(checked)]="includeDontShowAgain"></cs-toggle>
          </cs-item>

          <!-- Duration -->
          <cs-item vertical>
            <cs-label>Duration (ms, 0 for persistent):</cs-label>
            <cs-input [(value)]="toastDuration" type="number" [placeholder]="'3000' | untranslated"></cs-input>
          </cs-item>

          <!-- Action button -->
          <cs-item>
            <cs-label>Include Action Button:</cs-label>
            <cs-toggle [(checked)]="includeAction"></cs-toggle>
          </cs-item>

          <!-- Action button text (shown if includeAction is true) -->
          @if (includeAction) {
            <cs-item vertical>
              <cs-label>Action Button Text:</cs-label>
              <cs-input [(value)]="actionButtonText" [placeholder]="'Action' | untranslated"></cs-input>
            </cs-item>
          }

          <!-- Show Toast button -->
          <cs-item>
            <cs-button item-right (click)="showConfiguredToast()" [label]="'Show Toast' | untranslated"
              data-test="show-toast-button" fit-width>
            </cs-button>
          </cs-item>
        </cs-item-list>
      </cs-card-content>
    </cs-card>
  </cs-card-list>
</cs-content>
